import React from 'react'
import { Button } from 'src/components'
import { PageTitle } from 'src/components/PageTitle'
import { Filter } from 'src/assets/svg'
import { more } from 'src/assets/png'
import { ToggleViewTableMode } from 'src/components/CustomTable/components/ToggleViewTableMode'
import { ModelOptions } from 'src/components/CustomTable'
import { useStyles } from '../styles'

type Props = {
  mode: ModelOptions
  changeMode: (mode: ModelOptions) => void
  onToggleFilter?: () => void
  onCreate?: () => void
  filterDisabled?: boolean
  createDisabled?: boolean
  toggleDisabled?: boolean
}

export const AnimalHeader: React.FC<Props> = ({
  mode,
  changeMode,
  onToggleFilter,
  onCreate,
  filterDisabled,
  createDisabled,
  toggleDisabled
}) => {
  const styles = useStyles()

  return (
    <div className={styles.animalHeader}>
      <div className={styles.animalHeaderContent}>
        <PageTitle title='Gado' />

        <div className={styles.animalHeaderBtnContainer}>
          <ToggleViewTableMode activeMode={mode} changeMode={changeMode} disabled={toggleDisabled} />

          <Button
            className={`${styles.buttonOutlined} ${styles.buttonWrapper} ${styles.animalHeaderBtn}`}
            disabled={filterDisabled}
            onClick={onToggleFilter}
            outlined
          >
            <Filter className='icon' />
            FILTRAR
          </Button>

          <Button className={styles.buttonWrapper} onClick={onCreate} disabled={createDisabled}>
            <img src={more} alt='Incluir' />
            CADASTRAR
          </Button>
        </div>
      </div>
    </div>
  )
}
